import ym from "react-yandex-metrika";
import ReactPixel from "react-facebook-pixel";

// @ts-ignore
const VK = window.VK;
const pixel = new VK.Pixel("VK-RTRG-1042911-nhFy");

export const trackAddPosition = () => {
  ym("reachGoal", "AddFirstPosition");
  ReactPixel.trackCustom("AddFirstPosition");
  pixel.Event("AddFirstPosition");
};
export const trackLogIn = () => {
  ym("reachGoal", "LogIn");
  ReactPixel.trackCustom("LogIn", { status: true });
  pixel.Event("LogIn");
};
export const trackSignUp = () => {
  ym("reachGoal", "SignUp");
  ReactPixel.track("CompleteRegistration", { status: true });
  pixel.Event("SignUp");
};
export const trackCreateAlias = () => {
  ym("reachGoal", "CreateAlias");
  ReactPixel.trackCustom("CreateAlias", { status: true });
  pixel.Event("CreateAlias");
};
export const trackCreateOrder = () => {
  ym("reachGoal", "CreateOrder");
  ReactPixel.trackCustom("CreateOrder", { status: true });
  pixel.Event("CreateOrder");
};
export const trackBigGain = () => {
  ym("reachGoal", "BigGain");
  ReactPixel.trackCustom("BigGain", { status: true });
  pixel.Event("BigGain");
};


